import Vue from 'vue'

const VuePhoneNumberInput = require('vue-phone-number-input')
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

Vue.component('VuePhoneNumberInput', VuePhoneNumberInput)
